

export const index = 4;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/login/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/4.DsP50RcQ.js","_app/immutable/chunks/2pkelJKV.js","_app/immutable/chunks/DdPEVikY.js","_app/immutable/chunks/DTYEGOkv.js","_app/immutable/chunks/DkMK8g04.js","_app/immutable/chunks/B-Y5Gt5S.js"];
export const stylesheets = [];
export const fonts = [];
